import { QualityTypeEnum } from "@gtpl/shared-models/common-models";

export class MaterialInfoReq{
    workOrderNumber : any;
    variant : any;
    quality : any;
    plantId : number

    constructor(workOrderNumber : any,variant : any,quality : any,plantId : number){
        this.workOrderNumber = workOrderNumber
        this.variant = variant
        this.quality = quality
        this.plantId = plantId
    }
}